import styled from 'styled-components';
import { Alert } from '@src/components/ui';

export const Notification = styled(Alert)`
  margin: ${({ theme }) =>
    `${theme.spacing[8]} ${theme.spacing[8]} 0 ${theme.spacing[8]}`};
`;
